<template>
  <div class="wrapper">
    <div class="tabs-panel">
      <input type="radio" id="test1" name="tab" checked="checked" />
      <input type="radio" id="test2" name="tab" />
      <input type="radio" id="test3" name="tab" />
      <div class="tabs">
        <div class="tab">
          <label for="test1" onclick>
            <div class="content">
              <div class="text">Value</div>
            </div>
          </label>
        </div>
        <div class="tab">
          <label for="test2" onclick>
            <div class="content">
              <div class="text">Allocation</div>
            </div>
          </label>
        </div>
        <div class="tab">
          <label for="test3" onclick>
            <div class="content">
              <div class="text">Expected Earnings</div>
            </div>
          </label>
        </div>
      </div>
      <div class="separator"></div>
      <div class="panels">
        <div class="tab-panel" id="panel1">
          <AllActiveInvestment v-show="!showEmptyValueState" />
          <valueEmptyState
            @directToAllocation="directToAllocation"
            v-show="showEmptyValueState"
          />
        </div>
        <div class="tab-panel" id="panel2">Content 2</div>
        <div class="tab-panel" id="panel3">
          <div class="content">Content 3</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import valueEmptyState from '@/components/dashboard/valueEmptyState.vue'
import AllActiveInvestment from '@/components/dashboard/allActiveinvestment.vue'
import LenderService from '@/services/lenderService'

export default {
    name: 'Dashboard',
    components: {
        AllActiveInvestment,
        valueEmptyState
    },
    data () {
        return {
            notifications: [],
            name: null,
            showEmptyValueState: true
        }
    },
    mounted () {
        this.name = this.$store.state.userName
        this.showPendingTransactions()
        this.getVirtualAccountDetails()
    },
    methods: {
        async showPendingTransactions () {
            const response = await LenderService.getLenderPendingPayments()
            if (response.status === 200) {
                this.notifications = response.data.result
            }
        },
        resetNotifications () {
            this.notifications = []
        },
        directToAllocation () {
            document.getElementById('test2').checked = true
        },
        getVirtualAccountDetails () {
            LenderService.getVirtualAccountInfo().then((response) => {
                if (response.status === 200) {
                    if (response.data.disbursedAmount !== 0) {
                        this.showEmptyValueState = false
                    }
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@/sass/components/_dashboard-layout.scss";

.notifications {
  position: relative;
}

.icon {
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
}

$number-of-tabs: 3;

$separator-height: 2px;

@mixin user-select() {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.wrapper {
  width: 100%;
  margin: 0 auto;
}

/* Makes the checkbox hack work for Android 4.1.2 */
@-webkit-keyframes checkbox-hack-bugfix {
  from {
    padding: 0;
  }
  to {
    padding: 0;
  }
}
body {
  -webkit-animation: checkbox-hack-bugfix infinite 1s;
  background-color: #ffffff;
}
input[type="checkbox"],
input[type="radio"] {
  @include user-select();
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  clip: rect(0, 0, 0, 0);
  visibility: hidden;
  opacity: 0;
  transform: matrix3d(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  z-index: -1;

  @for $i from 1 through $number-of-tabs {
    &[id="test#{$i}"] {
      &:checked {
        & ~ .tabs {
          .tab {
            label[for="test#{$i}"] {
              color: #002fa7;
              cursor: default;

              &::after {
                opacity: 1;
              }
            }
          }
        }
        & ~ .panels {
          #panel#{$i} {
            display: block;
          }
        }
      }
    }
  }
}

.tabs-panel {
  .tabs {
    display: flex;
    border: solid;
    border-width: thin;
    border-color: #e0e0e0;

    .tab {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -ms-flex: 1;
      flex: 1;
      flex-basis: auto;
      /* We need to define flex-grow here aside from flex for IE10 because it defaults to something else. */
      flex-grow: 1;

      position: relative;
      width: 60%;
      margin-top: 30px; //40px
      margin-right: 0; //50px
      text-align: center;
      color: #9e9e9e;
      background-color: transparent;
      cursor: pointer;
      transition: background-color 0.3s, color 0.3s ease;

      label {
        @include user-select();
        display: block;
        height: 100%;
        padding: 0 3px;
        border: none;
        cursor: pointer;

        .content {
          .text {
            margin-bottom: 20px;
            font-family: "Inter", sans-serif;
            font-size: 16px;
            font-weight: 600;
          }
        }

        &::after {
          content: "";
          position: absolute;
          bottom: (-1) * $separator-height;
          left: 0;
          display: block;
          width: 100%;
          height: 3px;
          opacity: 0;
          background-color: #002fa7;
          transition: opacity 0.3s ease-in-out;
        }
      }

      &:hover {
        color: #002fa7;
      }
    }
  }
  .separator {
    width: 100%;
    background-color: #ffffff;
  }
  .panels {
    border: none;

    .tab-panel {
      display: none;
      border: none;

      .content {
        font-family: "Inter", sans-serif;
        color: #002fa7;
        animation: fade 0.3s linear;
      }
    }
  }
}
</style>
